export function initDefaultTooltips() {
  document.querySelectorAll('.js-tooltip').forEach(tooltipEl => {
    const btnEl = tooltipEl.querySelector('.js-tooltip-btn')
    const contentEl = tooltipEl.querySelector('.js-tooltip-content')

    btnEl.addEventListener('click', () => {
      btnEl.classList.toggle('active')
      contentEl.classList.toggle('active')
    })
  })
}
